"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Enumerable.MapSet", "slice", 1, "public", [{params: (context) => [Type.variablePattern("map_set_0")], guards: [], body: (context) => {
Interpreter.matchOperator(Elixir_MapSet["size/1"](context.vars.map_set_0), Type.variablePattern("size_1"), context);
Interpreter.updateVarsToMatchedValues(context);
return Type.tuple([Type.atom("ok"), context.vars.size_1, Type.functionCapture("MapSet", "to_list", 1, [{params: (context) => [Type.variablePattern("$1")], guards: [], body: (context) => {
return Elixir_MapSet["to_list/1"](context.vars["$1"]);
}}], context)]);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));